import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { authApi } from '../store/auth/authApi';
import { userAPI } from '../store/user/userApi';
import { userDomAPI } from '../store/user/userDomApi';
import userAccessSlice from '../store/brokers/partners/user-access-control/userAccessSlice';
import partnersSlice from '../store/brokers/partners/partners/partnersSlice';
import historyChatsSlice from '../store/brokers/partners/history-chats/historyChatsSlice';
import featuresReducer from '../store/features/featuresSlices';
import chatsSlice from '../store/slices/chats.slice';
import { chatboxApi } from '../store/chatbox/chatboxApi';
import { ttsApi } from '../store/chatbox/ttsApi';


export const store = configureStore({
    reducer: {
        [userAPI.reducerPath]: userAPI.reducer,
        [authApi.reducerPath]: authApi.reducer,
        [userDomAPI.reducerPath]: userDomAPI.reducer,
		[chatboxApi.reducerPath]: chatboxApi.reducer,
		[ttsApi.reducerPath]: ttsApi.reducer,
        userAccess: userAccessSlice,
        partners: partnersSlice,
        history: historyChatsSlice,
		features: featuresReducer,
		chats: chatsSlice,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(
            userAPI.middleware,
            authApi.middleware,
            userDomAPI.middleware,
			chatboxApi.middleware,
			ttsApi.middleware
        ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
